import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  Grid,
  SelectChangeEvent,
  useEventCallback,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';
import ModalityPaymentList from './modality-payment-list';
import IntendedUseList from './intended-use';
import TypePaymentList from './type-payment';
// import WithReportsList from './with-reports-list';
import { ModalityPaymentVM } from 'shell/view-models/modality-payment';
import { PPAA } from 'front-office/constants/payment-mode';
import PmiTextField from 'shell/components/shared/text-field';

interface PaymentCertificateProps {
  withReportsVisible?: boolean;
  useModeCode?: string | null;
  flagUseModeCode?: string | null;
  filterElementsUseMode?: (elements: Array<ModalityPaymentVM>) => Array<ModalityPaymentVM>;
  showHistoricalFields?: boolean;
}

const PaymentCertificateComponent = ({
  useModeCode,
  flagUseModeCode,
  filterElementsUseMode,
  showHistoricalFields = false,
}: // withReportsVisible = false,
PaymentCertificateProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificateFormVM>();

  useEffect(() => {
    if (formContext.values.certificateInternOnly && !formContext.values.modality?.id) {
      formContext.setValues({
        ...(formContext.values || {}),
        typePayment: 'C',
        modality: PPAA,
      });
    } else if (
      !formContext.values.certificateInternOnly &&
      formContext.values.modality?.id === PPAA.id
    ) {
      formContext.setValues({ ...(formContext.values || {}), modality: null, typePayment: '' });
    }
  }, [formContext.values.certificateInternOnly]);

  const handleModality = useEventCallback((modality: ModalityPaymentVM | undefined) => {
    formContext.setValues({
      ...formContext.values,
      modality,
      typePayment: modality?.registryType === 'ESENTE' ? 'C' : '',
    });
  });

  const handleIntendedUse = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('intendedUse', event.target.value);
  });

  const handleTypePayment = useEventCallback((event: SelectChangeEvent<string>) => {
    formContext.setFieldValue('typePayment', event.target.value);
  });

  const handleStampaFirmaOmessa = useEventCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    formContext.setFieldValue('stampaFirmaOmessa', event.target.checked);
  });

  const handleNote = useEventCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    formContext.setFieldValue('note', event.target.value);
  });

  // const handleWithReports = useEventCallback((event: SelectChangeEvent<string>) => {
  //   formContext.setFieldValue('withReports', event.target.value);
  // });

  return (
    <div className="pmi-pt-4">
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-certificate-payment-content"
          id="panel-certificate-payment-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Modalità di rilascio</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ModalityPaymentList
                onChange={handleModality}
                value={formContext.values?.modality}
                filterElements={filterElementsUseMode}
                flagUseModeCode={flagUseModeCode}
                useModeCode={useModeCode}
                disabled={
                  formContext.values.certificateInternOnly || formContext.values?.modality?.disabled
                }
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <IntendedUseList
                onChange={handleIntendedUse}
                value={formContext.values?.intendedUse || ''}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TypePaymentList
                onChange={handleTypePayment}
                value={formContext.values?.typePayment || ''}
              />
            </Grid>
            {showHistoricalFields && (
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formContext.values?.stampaFirmaOmessa || false}
                      onChange={handleStampaFirmaOmessa}
                      name="stampaFirmaOmessa"
                    />
                  }
                  label="Stampa firma omessa"
                />
              </Grid>
            )}
            {showHistoricalFields && (
              <Grid item xs={12}>
                <PmiTextField
                  id="note"
                  name="note"
                  label="Note del certificato"
                  multiline
                  rows={4}
                  fullWidth
                  value={formContext.values?.note || ''}
                  onChange={handleNote}
                />
              </Grid>
            )}
            {/* {withReportsVisible ? (
              <Grid item xs={12} md={8}>
                <WithReportsList
                  onChange={handleWithReports}
                  value={formContext.values?.withReports || ''}
                />
              </Grid>
            ) : undefined} */}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

PaymentCertificateComponent.displayName = 'Accordion payment certificate component';

const PaymentCertificate = memo(PaymentCertificateComponent);

export default PaymentCertificate;
